import * as React from 'react';
import { FLEX_COLUMN, FLEX_CENTERED } from '../../layout/flexBox';
import { PLAIN_GREEN_LINKS } from '../../forms/styles/links';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import LogoBox from '../../branding/LogoBox';
import { Loader } from '../../loading/Loader';
import { motion } from 'framer-motion';
import { useWindowSize } from '../../core/hooks/useWindowSize';
import LoginFooter from './LoginFooter';
import { onMobileDevice } from '../../globalStyle/mediaQueries';


const styles = {
  root:            [
    FLEX_COLUMN,
    FLEX_CENTERED,
    PLAIN_GREEN_LINKS,
    css`
      color: ${COLORS.DARK_GREY};
      margin-top: 120px;
      ${onMobileDevice} {
        margin-top: 0;
      }
    `,
  ],
  content:         [
    FLEX_COLUMN,
    css`
      align-items: center;
      justify-content: flex-start;
    `,
  ],
  logoContainer:   [
    css`display: flex;`,
    FLEX_CENTERED,
  ],
  logo:            css`padding-bottom: 18px;`,
  formContainer:   css`
    margin: auto 24px;
    max-width: 312px;
  `,
  headerMsg:       css`
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
  `,
  loaderContainer: [
    FLEX_COLUMN,
    FLEX_CENTERED,
    css`
      align-items: center;
      height: 14vh;
      flex-grow: 1;
    `,
  ],
  loader:          css`width: 30px;`,
};

type Props = {
  className?: string;
  isLoading: boolean;
  headerMsg?: string;
};


/**
 * LoginLayout: a template component that encapsulates elements common to all of the various pages which comprise the
 * login flow.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
const LoginLayout: React.FC<Props> = props => {
  const { isMobile } = useWindowSize();

  return (
    <div css={styles.root}>
      <div css={styles.content}>
        <div css={styles.logoContainer}>
          <LogoBox css={styles.logo} />
        </div>
        <div css={styles.formContainer}>
          {
            !!props.headerMsg && (
              <div css={styles.headerMsg}>
                {props.headerMsg}
              </div>
            )
          }
          {props.children}
        </div>
        <div css={styles.loaderContainer}>
          {
            props.isLoading && (
              <motion.div animate={{ scale: [0, 1], opacity: [0, 1] }} transition={{ duration: 2 }}>
                <Loader css={styles.loader} />
              </motion.div>
            )
          }
        </div>
        <LoginFooter isMobile={isMobile} />
      </div>
    </div>
  );
};


export default LoginLayout;
